import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  Home, BookOpen, UserRound, LifeBuoy, LayoutDashboard, Users, CalendarDays,
  Route as RouteIcon, Settings,
} from "lucide-react";

// Per-profile bottom navigation. Reuses existing routes; patient "Pedir ajuda"
// is the central, highlighted red action.
const CFG = {
  patient: [
    { to: "/", label: "Início", icon: Home },
    { to: "/jornada", label: "Jornada", icon: RouteIcon },
    { to: "/apoio", label: "Pedir ajuda", icon: LifeBuoy, center: true },
    { to: "/conteudos", label: "Conteúdos", icon: BookOpen },
    { to: "/perfil", label: "Perfil", icon: UserRound },
  ],
  professional: [
    { to: "/", label: "Início", icon: LayoutDashboard },
    { to: "/pacientes", label: "Pacientes", icon: Users },
    { to: "/agenda", label: "Agenda", icon: CalendarDays },
    { to: "/conteudos", label: "Conteúdos", icon: BookOpen },
    { to: "/perfil", label: "Perfil", icon: UserRound },
  ],
  org_admin: [
    { to: "/", label: "Início", icon: LayoutDashboard },
    { to: "/pacientes", label: "Pacientes", icon: Users },
    { to: "/admin", label: "Profissionais", icon: Users },
    { to: "/conteudos", label: "Conteúdos", icon: BookOpen },
    { to: "/perfil", label: "Gestão", icon: Settings },
  ],
};

const slug = (s) => s.toLowerCase().replace(/\s/g, "-");

export default function BottomNav() {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const items = CFG[user?.role];
  if (!items) return null;
  const isActive = (to) => (to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to));

  return (
    <nav
      data-testid="bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-[#E0F2FE]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-xl mx-auto grid grid-cols-5 items-end px-1">
        {items.map((it) => {
          const active = isActive(it.to);
          const Icon = it.icon;
          if (it.center) {
            return (
              <button
                key={it.to}
                data-testid={`bottomnav-${slug(it.label)}`}
                onClick={() => nav(it.to)}
                className="flex flex-col items-center justify-end -mt-5"
              >
                <span className={`w-14 h-14 rounded-full grid place-items-center text-white shadow-lg shadow-red-500/30 transition-colors ${active ? "bg-[#dc2626]" : "bg-[#EF4444]"}`}>
                  <Icon size={24} />
                </span>
                <span className="text-[10px] font-semibold text-[#EF4444] mt-0.5 mb-1">{it.label}</span>
              </button>
            );
          }
          return (
            <button
              key={it.to}
              data-testid={`bottomnav-${slug(it.label)}`}
              onClick={() => nav(it.to)}
              className={`flex flex-col items-center gap-0.5 py-2 transition-colors ${active ? "text-[#0F766E]" : "text-[#94A3B8]"}`}
            >
              <Icon size={22} className={active ? "" : "opacity-80"} />
              <span className="text-[10px] font-medium leading-none">{it.label}</span>
              <span className={`w-1 h-1 rounded-full ${active ? "bg-[#0F766E]" : "bg-transparent"}`} />
            </button>
          );
        })}
      </div>
    </nav>
  );
}
